document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.section');

    sections.forEach(function(section) {
      const sectionId = section.getAttribute('id');
      const header = section.querySelector('.product-title-main, .product-title-alt');

      if (header) {
        const icon = document.createElement('span');
        icon.className = 'accordion-icon';
        header.appendChild(icon);

        const contentElements = [];
        let nextElement = header.nextElementSibling;

        while (nextElement && !nextElement.matches('.product-title-main, .product-title-alt')) {
          contentElements.push(nextElement);
          nextElement = nextElement.nextElementSibling;
        }

        if (contentElements.length > 0) {
          const contentWrapper = document.createElement('div');
          contentWrapper.className = 'section-content';

          const innerWrapper = document.createElement('div');
          innerWrapper.className = 'section-content-inner';

          contentElements.forEach(element => {
            innerWrapper.appendChild(element);
          });

          contentWrapper.appendChild(innerWrapper);
          header.after(contentWrapper);

          if (sectionId === 'description' || sectionId === 'features') {
            section.classList.add('active');
          }

          header.addEventListener('click', function(e) {
            if (e.target.tagName.toLowerCase() === 'a') return;

            section.classList.toggle('active');

            contentWrapper.setAttribute('aria-expanded', section.classList.contains('active'));

            if (typeof window.dataLayer !== 'undefined') {
              window.dataLayer.push({
                'event': 'product_accordion_toggle',
                'accordion_section': sectionId,
                'accordion_action': section.classList.contains('active') ? 'open' : 'close'
              });
            }
          });

          contentWrapper.setAttribute('aria-expanded', section.classList.contains('active'));
        }
      }
    });
  });